import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";
 
import { getImagesByQuery } from "./js/pixabay-api.js";
import { createGallery, clearGallery, showLoader, hideLoader, hideLoadMoreButton, showLoadMoreButton, smoothScroll } from './js/render-functions.js';

const form = document.querySelector('.form');
const loadMoreBtn = document.querySelector('.load-more-btn');


let query = '';
let page = 1;
let totalHits = 0;


form.addEventListener('submit', onSearch);
loadMoreBtn.addEventListener('click', onLoadMore);

async function onSearch(event) {
    event.preventDefault();

    query = event.target.elements['search-text'].value.trim();

    if (!query) {
        iziToast.warning({
            message: 'Please enter a search query.',
            position: 'topRight',
        });
        return;
    }
    page = 1;
    clearGallery();
    hideLoadMoreButton();
    showLoader();


    try {
        const data= await getImagesByQuery(query, page);
totalHits = data.totalHits;

     if (!data.hits.length){
            iziToast.error({
                message: 'Sorry, there are no images matching <br>your search query. Please, try again!',
                position: 'topRight',
                backgroundColor: '#e74c3c',
    messageColor: '#ffffff',
    iconColor: '#ffffff',
    icon: 'ico-error', 
    theme: 'dark',
    close: true,
    closeColor: '#ffffff',
            });
            return;
}

    createGallery(data.hits);

    if (totalHits > 15) { 
             showLoadMoreButton()}

    checkEndOfCollection();

    } catch (error) {
        iziToast.error({
            message: 'Sorry, there are no images matching <br>your search query. Please, try again!',
            position: 'topRight',
            backgroundColor: '#e74c3c',
    messageColor: '#ffffff',
    iconColor: '#ffffff',
    icon: 'ico-error', 
    theme: 'dark',
    close: true,
    closeColor: '#ffffff',
        });
        console.error('Error fetching images:', error);
    } finally {
        hideLoader();
    }
}

async function onLoadMore() {
    page += 1;
    hideLoadMoreButton();
    showLoader();

    try {
        const data = await getImagesByQuery(query, page);
        createGallery(data.hits);
        showLoadMoreButton();
        checkEndOfCollection();
        smoothScroll();
        
    } catch (error) {
        iziToast.info({
        message: 'Sorry, there are no images matching <br>your search query. Please, try again!',
        position: 'topRight'
        });
        console.error('Error loading more images:', error);
    } finally {
        hideLoader();
    }
}

function checkEndOfCollection() {
    const shownImages = document.querySelectorAll('.gallery li').length;

    if (shownImages >= totalHits) {
        hideLoadMoreButton();
        iziToast.info({
            message: "We're sorry, but you've reached the end of search results.",
            position: 'topRight',
        });
    }
}
